import { BaseService } from 'core/services';
import FacilityPumpRouteService from './FacilityPumpRouteService';

class FacilityPumpService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new FacilityPumpRouteService());
    }

    async getStatus(){
        const url = this.routeService.getStatus();
        const response = await this.apiClient.get(url);
        return response.data || null;
    }

    async updateStatus(resource){
        const url = this.routeService.updateStatus(resource);
        const response = await this.apiClient.put(url,resource);
        return response.data || null;
    }

    async getActiveNumber(facilityId){
        const url = this.routeService.getActiveNumber(facilityId);
        const response = await this.apiClient.get(url);
        return response.data || null;
    }

    async getExisting(facilityId, productId, serialNumber){
        const url = this.routeService.getExisting(facilityId, productId, serialNumber);
        const response = await this.apiClient.get(url);
        return response.data;
    }

    getDownloadUrl(filter){
        return this.apiClient.appOptions.apiUrl + this.routeService.download(filter);
    }
}

export default FacilityPumpService;
